import React from 'react';
import { Query } from '@apollo/client/react/components';
import { GET_STORES } from 'apollo/queries';
import { productsClient } from 'apollo';

/**
 * Given a list of stores, parse spins and nielsen tags and make the proper queries (one query for
 * all spins tags and another for the nielsen tags, also if a store includes a spins tag, will use
 * this one instead of the nielsen one). Returns the query component body, which should be null as
 * we only want to query the stores.
 * @param clientId
 * @param stores
 * @param onCompleted - Callback called after the query finish.
 */
export const queryStores = (
  clientId: string,
  stores: Array<any>,
  onCompleted: (data: any) => void
) => {
  const queryStore = (keyVariable: object) => {
    return (
      <Query
        query={GET_STORES}
        client={productsClient as any}
        variables={{
          clientId,
          ...keyVariable
        }}
        fetchPolicy="network-only"
        onCompleted={data => {
          onCompleted(data.getStore);
        }}
      >
        {() => {
          return null;
        }}
      </Query>
    );
  };
  if (stores.length > 0) {
    return queryStore({ storeTag: stores.join(',') });
  }
  return null;
};
